/**
 * ENCRYPTION SERVICE - Re-export from Shared Core
 * 
 * Mantiene compatibilidad con imports existentes.
 * La implementación real está en @boosting/core.
 */

// Re-export from shared package
export {
  EncryptionService,
  createEncryptionService,
  type EncryptedField,
} from '@boosting/core';

// Create singleton instance for backwards compatibility
import { createEncryptionService } from '@boosting/core';
export const encryptionService = createEncryptionService();
